import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #30: Dipping my toes in React Native",
  "description": "",
  "published": "2017-01-17T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-30-dipping-toes-react-native/swizec/7380"],
  "categories": "Front End, Livecoding, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New streams almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`After many weeks without Livecoding, we hung out again – all 10 of us. It was great ☺️`}</p>
    <p>{`I dipped my toes in React Native and got some help from @nashio and @blackburn1911. They've done it before or had better luck with Google. Both?`}</p>
    <p>{`We built a Hello World app that lets you browse through 6 of my Instagram photos. Tap on the right to go `}<em parentName="p">{`next`}</em>{`, tap on the left to go `}<em parentName="p">{`previous`}</em>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/my-first-react-native-app-4.gif",
        "alt": null
      }}></img></p>
    <p>{`Sure, it would be more intuitive to swipe, but Snapchat uses taps for going back and forth in stories, and that's my excuse. I also don't know how to make swipes.`}</p>
    <p>{`The funny thing about starting with React Native is that googling `}<inlineCode parentName="p">{`react native`}</inlineCode>{` gives you two big results. `}<a parentName="p" {...{
        "href": "https://facebook.github.io/react-native/"
      }}>{`The official documentation`}</a>{` and `}<a parentName="p" {...{
        "href": "http://www.reactnative.com/"
      }}>{`reactnative.com`}</a>{`.`}</p>
    <p>{`I clicked reactnative.com and got confused immediately.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/reactnative.com-screenshot-2.png",
        "alt": null
      }}></img></p>
    <p>{`Okay, the new release cadence is monthly. Great! But how do I start using this thing? What do I do next? How do I begin? Do I need Xcode? Can I develop in a normal editor? Should I download a specialized IDE? WHAT DO I DO?`}</p>
    <p>{`Then I tried the official docs.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/official-docs-screenshot-3.png",
        "alt": null
      }}></img></p>
    <p><inlineCode parentName="p">{`Get Started With React Native`}</inlineCode>{`. That looks promising!`}</p>
    <p>{`And boy, was it ever. Turns out™ you don't need much to start: `}<inlineCode parentName="p">{`node`}</inlineCode>{`, `}<inlineCode parentName="p">{`watchman`}</inlineCode>{`, and `}<inlineCode parentName="p">{`react-native-cli`}</inlineCode>{`. Docs say `}<inlineCode parentName="p">{`watchman`}</inlineCode>{` isn't mandatory, but it makes life better. ¯`}{`\\`}<em parentName="p">{`(ツ)`}{`_`}{`/¯`}</em></p>
    <p>{`You need Xcode for the iOS simulator. If you're doing Android, you'll need that simulator, too.`}</p>
    <p>{`Then you run `}<inlineCode parentName="p">{`react-native init NativeHelloWorld`}</inlineCode>{`, and it creates a bunch of things that I don't understand. When you run the simulator with `}<inlineCode parentName="p">{`react-native run-ios`}</inlineCode>{`, a simulator shows up with your new app.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/initial-simulator-screenshot-1.png",
        "alt": null
      }}></img></p>
    <p>{`Simulators, it turns out, are huge. Even on my big fat Apple Thunderbolt display. Maybe I should get one of those new 4K monsters ?`}</p>
    <p>{`Running `}<inlineCode parentName="p">{`react-native run-ios`}</inlineCode>{` also opens a terminal with something called React Packager. Don't know what it is, but it looks necessary. I assume it's a compiler.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/react-packager-screnshot-1.png",
        "alt": null
      }}></img></p>
    <p>{`Poking around the React Native API was fun, and we learned a few things:`}</p>
    <ol>
      <li parentName="ol">{`There's no `}<inlineCode parentName="li">{`onClick`}</inlineCode>{`. To detect tap events, you should wrap components in `}<inlineCode parentName="li">{`TouchableHighlight`}</inlineCode>{`, which takes one and only one child element. I think this is silly.`}</li>
      <li parentName="ol">{`Styling happens through the `}<inlineCode parentName="li">{`style=`}</inlineCode>{` prop. There's no CSS. Or at least the project initiating script heavily promotes avoiding stylesheets.`}</li>
      <li parentName="ol">{`Layouting through Flexbox is encouraged. I assume you can do whatever you want, and Flexbox is the Best Practice™.`}</li>
      <li parentName="ol">{`If you use hot loading and add `}<inlineCode parentName="li">{`state`}</inlineCode>{`, you have to reload the app. Otherwise, `}<inlineCode parentName="li">{`render()`}</inlineCode>{` gets called without `}<inlineCode parentName="li">{`state`}</inlineCode>{` getting initialized. That was a fun gotcha.`}</li>
      <li parentName="ol">{`Images don't size themselves. Without sizing, they're invisible.`}</li>
      <li parentName="ol">{`Debugging happens in a browser window, not the simulator. This feels funny.`}</li>
    </ol>
    <p>{`Overall, I'm impressed with how easy it was to get started. If you know React, you should be able to build cool stuff.`}</p>
    <p>{`Now we’ve just gotta figure out why `}<inlineCode parentName="p">{`index.android.js`}</inlineCode>{` is separate from `}<inlineCode parentName="p">{`index.ios.js`}</inlineCode>{`, learn more mobile development principles, then get an interesting project to poke at.`}</p>
    <p>{`Ideas?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      